import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { formatDataForDataTable } from '../../utils/formatData';

const initialState = {
  loading: false,
  data: [],
};

export const navigateToTodo = createAsyncThunk('todo/navigateToTodo', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: 'todo/interval',
    data: data,
  });
  return res;
});

const intervalTodoSlice = createSlice({
  name: 'intervalTodoSlice',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    //.................navigateToTodo..............................
    builder.addCase(navigateToTodo.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(navigateToTodo.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

export default intervalTodoSlice.reducer;
